import { Component, Input, OnInit } from "@angular/core";
import { AbstractControl, FormGroup, NgForm, NgModel } from "@angular/forms";

/**
 * We support custom errors that include a value such as min and max.
 * More can be added into the components html file and here in this
 * interface.
 */
export interface KnownFieldAttributes {
  min?: number;
  max?: number;
}
@Component({
  selector: 'app-error-msg',
  templateUrl: './inline-message.component.html',
  styleUrls: ['./inline-message.component.scss']
})
export class InlineMessageComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() field!: NgModel | AbstractControl<any,any>;
  @Input() fieldTwo ?: NgModel;
  @Input() fieldLabel?: string = 'The field ';
  @Input() form?: NgForm;
  @Input() fg?: FormGroup;
  @Input() attrs?: KnownFieldAttributes;
  @Input() customLengthMessage?: boolean = false;
  @Input() customLengthMessageContent?: string;

  @Input() fieldName?: string;
  @Input() otherFieldLabel?: string;

  // set to true to see error structure of field on page.
  @Input() debug = false;

  JSON = JSON;

  ngOnInit(): void {

    // check the global setting.
    const globalDebug = localStorage.getItem('scr.inlinemessage.debug');
    if (globalDebug !== null) {
      this.debug = globalDebug === 'true';
    }

    // look it up by form.
    if (!this.field && this.form && this.fieldName) {
      this.field = this.form?.controls[this.fieldName];
    }

    // look it up by form group.
    if (!this.field && this.fg && this.fieldName) {
      let fg = this.fg;
      const spl = this.fieldName.split('.');
      spl.forEach((nm,idx) => {
        if (idx === spl.length - 1) {
          const ctrl = fg.get(nm);
          if (ctrl) {
            this.field = ctrl;
          }
          else {
            console.error('unable to find control ' + nm);
          }
        }
        else {
          const grp = fg.get(nm) as FormGroup;
          if (grp) {
            fg = grp;
          }
          else {
            console.error('unable to find form group ' + nm);
          }
        }
      });
      if (this.debug) {
        console.debug('set field ' + this.fieldName + ' to ' + this.field);
      }
    }

    // find the label if it is not set.
    if ((!this.fieldLabel || this.fieldLabel === 'The field ') && this.fieldName) {
      if (this.debug) {
        console.debug('find field label for ' + this.fieldName);
      }
      const lbl = document.querySelector(`label[for="${this.fieldName}"]`) as HTMLLabelElement;
      if (this.debug) {
        console.debug('found ' + lbl + ' ' + lbl.textContent);
      }
      if (lbl && lbl.textContent) {
        this.fieldLabel = lbl.textContent;
      }

    }
  }
}